import React from "react";

import { useAppSelector } from "hooks/store";

import { interfaceElementsSelector } from "store/slices/themeSlice";

import { INTERFACE_ELEMENTS } from "themes/constants";

import logo from "../../../resources/images/dron-selfie-logo.png";

import styles from "./footer.module.css";

const Footer = () => {
  const interfaceElements = useAppSelector(interfaceElementsSelector);
  return (
    <>
      {interfaceElements.includes(INTERFACE_ELEMENTS.FOOTER) && (
        <div className={styles.footer}>
          <div className={styles.container}>
            <span className={styles.copyright}>
              Copyright &copy; <b>{new Date(Date.now())?.getFullYear()}</b>
            </span>
            <div className={styles.divider} />
            <img src={logo} alt="Drone Selfie" className={styles.logo} />
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
